module.exports = __webpack_public_path__ + "static/media/memory_life_1.58582e7c.jpeg";